import Image from 'next/image';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid';

import { Column, Row, Section } from './Section';
import { Text } from './Text';
import { QuoteFormState } from './QuoteForm';
import { AgentQuoteHeaderFragment } from './AgentQuoteHeader.generated';
import Link from 'next/link';

interface AgentQuoteHeaderProps {
  step: QuoteFormState['step'];
  agent: AgentQuoteHeaderFragment;
}

export const AgentQuoteHeader: React.FC<AgentQuoteHeaderProps> = ({
  step,
  agent,
}) => (
  <Section background="WHITE" className="py-4 lg:py-8">
    <Row inset className="items-center">
      <Column className="max-w-max !mb-0">
        {agent.photo?.url && (
          <Image
            src={agent.photo.url}
            alt={agent.photo.description ?? ''}
            width={110}
            height={110}
            className="rounded-full"
            priority
          />
        )}
      </Column>
      <Column>
        <Text.H1 className="!text-xl md:!text-2xl !font-medium !mb-1">
          <Link href={`/agents/${agent.slug}`}>{agent.name}</Link>
        </Text.H1>
        <p className="text-blue-600 !mb-1 text-xs">
          Licensed Blue Cross NC Agent
        </p>
        <Text.Small className="!text-gray-500 font-medium !text-xs">
          Licensed since {agent.licensedYear}
        </Text.Small>
        {agent.phoneNumber && (
          <a
            href={`tel:${agent.phoneNumber}`}
            className="block text-blue-600 hover:text-blue-700 !mb-0"
          >
            <PhoneIcon className="w-4 inline mr-2" />
            {parsePhoneNumberFromString(
              `+${agent.phoneNumber}`,
            )?.formatNational()}
          </a>
        )}
        {agent.email && (
          <a
            href={`mailto:${agent.email}`}
            className="block text-blue-600 hover:text-blue-700"
          >
            <EnvelopeIcon className="w-4 inline mr-2" />
            {agent.email}
          </a>
        )}
      </Column>
      <Column>
        {step === 'BASICS' && (
          <p className="text-gray-500">
            Let&apos;s get you started. I just need a few details to send you a
            quote and provide you with personalized plan options for comparison.
          </p>
        )}
        {step === 'SUBMIT' && (
          <p className="text-gray-500">That’s it! I’m preparing your quote.</p>
        )}
      </Column>
    </Row>
  </Section>
);
